// Phase 1A Phase 9C.10b — PhantomSlipPanel premium-rails sibling.
//
// Token-only sibling overlay. The parent
// `phantom-slip-panel.styles.ts` was previously at saturation; new
// chrome vocabulary for the 9C.10b premium pass lives here.
// Consumers continue to import the existing chrome from the parent
// file and spread these rails on top where needed.
//
// Trust contract:
//   - No raw hex/rgb. No icons. No emoji.
//   - cardLow + transitionStandard come from the canonical 9C
//     elevation + motion helpers.
//   - No glow, no fake live pulse, no selected-card amber ring.
//     The Phantom panel renders simulated state only — never an
//     execution affordance.

import type { CSSProperties } from "react";

import { cardLow } from "../../styles/elevation.ts";
import { transitionStandard } from "../../styles/motion.ts";

// ─── Card elevation + motion ────────────────────────────────────
//
// Spread on top of the parent file's `wrap` and the dashboard.styles
// `card` constant so each Phantom card sits on the same visual plane
// as the 9C /home, /vault, /exchange, and /brief premium surfaces.

export const cardRails: CSSProperties = {
  ...cardLow,
  ...transitionStandard,
};

// ─── Header lead row (icon + eyebrow) ───────────────────────────
//
// Inline-flex anchor so the registered icon sits beside the
// existing `cardEyebrow` text without restructuring the parent
// flex column.

export const headerLead: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
  color: "var(--sz-text-secondary)",
};

// ─── Fixture row lead (icon + matchup) ──────────────────────────
//
// Spread on top of the existing `fixtureTeams` style so each
// fixture row leads with a small Football icon adjacent to the
// matchup label.

export const fixtureLead: CSSProperties = {
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--sz-space-2)",
  color: "var(--sz-football)",
};
